import { IEventListeners, Event } from './Event';

let onNotificationEvent: Event<INotification> = new Event<INotification>();

export enum LogLevel {
  Error,
  Warning,
  Info,
  Verbose
}

export enum Category {
  Core,
  Sink,
  Transport
}

export interface INotification {
  level: LogLevel;
  category: Category;
  message: () => string;
}

/**
 * Returns a list of notification event listeners. You can add an event listener:
 *    onNotification().addListener(event =\> \{
 *      console.log(event!.message + ' ' + event!.level); \});
 *
 * DO NOT trigger telemetry events on these notifications, as doing so may
 * create an infinite loop of telemetry events.
 */
export function onNotification(): IEventListeners<INotification> {
  return onNotificationEvent;
}

/**
 * Internal function: log a notification
 * @param level - The level of notification to log
 * @param category - The category of the notification
 * @param message - A function that returns a message to log
 */
export function logNotification(level: LogLevel, category: Category, message: () => string) {
  onNotificationEvent.fireEvent({ level, category, message });
}

/**
 * Internal function: log an error
 * @param category - The category of the notification
 * @param message - A message that will preceed the message from error object
 * @param error - An error object, from which an error message might be obtained
 */
export function logError(category: Category, message: string, error: any) {
  logNotification(LogLevel.Error, category, () => {
    let errorMessage = error instanceof Error ? error.message : '';
    return `${message}: ${errorMessage}`;
  });
}
